import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../node_modules/swiper/swiper.css';
import ProductsDestacados from './productos';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { fetchDestacadas, fetchUltimas } from '../../json/Datos';

const MINIMO = 10;
const TOPE = 12;

// R: reservada, S: suspendida, V: vendida, A: alquilada — no tiene sentido
// usarlas de anzuelo en la Home si no están disponibles.
const NO_DISPONIBLES = ['R', 'S', 'V', 'A'];
const estaDisponible = (ficha) => !NO_DISPONIBLES.includes(ficha.disponibilidad);

const MySwiperComponent = ({ catalogoCompleto = [] }) => {
  const [slides, setSlides] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let cancelado = false;

    const cargar = async () => {
      try {
        const [destacadas, ultimas] = await Promise.all([
          fetchDestacadas().catch(() => []),
          fetchUltimas().catch(() => [])
        ]);

        const vistos = new Set();
        let combinado = [...destacadas, ...ultimas]
          .filter(estaDisponible)
          .filter((ficha) => {
            if (vistos.has(ficha.id)) return false;
            vistos.add(ficha.id);
            return true;
          });

        // Si no se llega al mínimo, se completa con el resto del catálogo
        // (también disponible, sin repetir lo que ya está).
        if (combinado.length < MINIMO) {
          const relleno = catalogoCompleto.filter(
            (ficha) => estaDisponible(ficha) && !vistos.has(ficha.id)
          );
          combinado = [...combinado, ...relleno];
        }

        if (!cancelado) {
          setSlides(combinado.slice(0, TOPE));
          setCargando(false);
        }
      } catch (error) {
        console.error('Error al traer propiedades para la Home:', error);
        if (!cancelado) {
          setSlides(catalogoCompleto.filter(estaDisponible).slice(0, TOPE));
          setCargando(false);
        }
      }
    };

    cargar();
    return () => { cancelado = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogoCompleto]);

  const linkStyle = {
    position: 'relative',
    marginTop: '15px',
    marginLeft: '90%',
    marginBottom: '-10px'
  };

  let slidesPerView = 4;
  if (window.innerWidth < 768) {
    linkStyle.marginLeft = '80%';
    slidesPerView = 1.2;
  } else if (window.innerWidth > 768 && window.innerWidth < 1100) {
    slidesPerView = 2;
  } else if (window.innerWidth > 1100 && window.innerWidth < 1500) {
    slidesPerView = 3;
  }

  if (cargando) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  if (slides.length === 0) {
    return null;
  }

  return (
    <div>
      <div style={linkStyle}>
        <Link to={'/Propiedades'} className='btn'>
          Ver Todos
        </Link>
      </div>
      <Swiper
        spaceBetween={50}
        slidesPerView={slidesPerView}
        style={{ paddingLeft: "4rem" }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className='borde shadow mb-6 mt-4'>
              <ProductsDestacados {...slide} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MySwiperComponent;
